import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-frontdesk',
  templateUrl: './frontdesk.component.html',
  styleUrls: ['./frontdesk.component.scss']
})
export class FrontdeskComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
